import React from 'react';
import {Totals} from '../../../../../common/components/Totals/Totals';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {AdditionalFeeModel} from '../../../../../domain/models/checkout/CartSummary/AdditionalFee.model';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';

export const AdditionalFeeRows = () => {
  const localeKeys = useLocaleKeys();
  const {isCartSummaryUpdating, cartSummary} = useControllerProps().checkoutStore;
  const additionalFees = cartSummary!.additionalFees;
  if (!additionalFees.length) {
    return;
  }
  const getAdditionalFeeValue = (additionalFee: AdditionalFeeModel) => {
    return isCartSummaryUpdating ? () => <TotalUpdateSkeleton /> : additionalFee.price.formattedAmount;
  };

  if (additionalFees.length === 1) {
    return (
      <Totals.TotalsRow
        dataHook={TotalsSectionDataHooks.AdditionalFeeRow}
        title={additionalFees[0].name}
        value={getAdditionalFeeValue(additionalFees[0])}
      />
    );
  }
  return (
    <Totals.TotalsSection
      title={localeKeys.checkout.additionalFees()}
      dataHook={TotalsSectionDataHooks.AdditionalFeesSection}>
      {additionalFees.map((fee) => (
        <Totals.TotalsRow
          dataHook={TotalsSectionDataHooks.AdditionalFeeRow}
          key={fee.code}
          title={fee.name}
          value={getAdditionalFeeValue(fee)}
        />
      ))}
    </Totals.TotalsSection>
  );
};
